


































































































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import MixinChartRaw from '@/plugins/podolib/services/helper/mixins/chart/raw';

@Component
export default class ChartRunningPhaseRunSteps extends Mixins(MixinChartRaw) {
  @Prop({ required: false, default: true }) globalType!: boolean;
  @Prop({ default: 0 }) index!: number;

  getData(side: string, data: string) {
    let value = this.globalType
      ? this.values.aggregates[side][data].avg.toFixed(1)
      : this.values.segments[this.index][side].result.aggregates[data].avg.toFixed(1);
    return parseFloat(value);
  }
  get doubleFlight() {
    let flight_time = (this.getData('left', 'percent_flight_time') + this.getData('right', 'percent_flight_time')) / 2;
    let contact_time =
      (this.getData('left', 'percent_contact_time') + this.getData('right', 'percent_contact_time')) / 2;
    let data = ((flight_time - contact_time) / 2).toFixed(0);
    // return parseFloat(data);
    return data;
  }
}
